<!-- <app-navbar-style-two></app-navbar-style-two> -->
<div class="orders-container">
  <h2 class="welcome">My Orders</h2>

  <div *ngFor="let order of orders" class="order-card">

    <!-- HEADER -->
    <div class="order-header" (click)="order.open = !order.open">
      <div class="left">
        <div class="order-code">Order #{{order.order_code}}</div>
        <div class="order-date">
         {{ formatOrderDate(order.ordered_at) }}
        </div>
      </div>

      <!-- <div class="right">
         <button
          *ngIf="canCancelOrder(order)"
          class="cancel-btn"
          [disabled]="cancellingOrderId === order.order_id"
          (click)="cancelOrder(order.order_id)">

          <span
            *ngIf="cancellingOrderId === order.order_id"
            class="spinner">
          </span>

          {{ cancellingOrderId === order.order_id ? 'Cancelling...' : 'Cancel' }}

        </button>
        <span class="status" [ngClass]="{
            'danger': order.status === 'Cancelled',
            'delivered': order.status !== 'Cancelled'
          }">
          {{ order.status }}
        </span>
        <span class="total">${{order.order_total}}</span>
        <span class="toggle">{{order.open ? '▲' : '▼'}}</span>
      </div> -->
      
      <div class="right">

        <div class="cancel-section" *ngIf="canCancelOrder(order)">

          <span class="cancel-timer">
            <i class="fa fa-clock-o"></i>
            Cancel available for
            <strong>{{ getRemainingTime(order) }}</strong>
          </span>

          <button
            class="cancel-btn"
            [disabled]="cancellingOrderId === order.order_id"
            (click)="cancelOrder(order.order_id)">

            <span
              *ngIf="cancellingOrderId === order.order_id"
              class="spinner">
            </span>

            {{
              cancellingOrderId === order.order_id
                ? 'Cancelling...'
                : 'Cancel Order'
            }}

          </button>

          

        </div>

        <span class="status" [ngClass]="{
            'danger': order.status === 'Cancelled',
            'delivered': order.status !== 'Cancelled'
          }">
          {{ order.status }}
        </span>

        <span class="total">${{order.order_total}}</span>

        <span class="toggle">{{order.open ? '▲' : '▼'}}</span>

      </div>

    
    
    </div>

   
    <div class="order-body" *ngIf="order.open">
      <div *ngFor="let item of order.items" class="item-row">

        <img [src]="data.base_url + item.item_image" class="item-img">

        <div class="item-details">
          <div class="item-name">{{item.item_name}}</div>
          <div class="item-meta">
            ${{item.item_price}} × {{item.quantity}}
          </div>
        </div>

        <div class="item-total">${{item.item_total}}</div>
      </div>

      <div class="order-footer d-none">
        <button class="reorder-btn">Reorder</button>
      </div>
    </div>

  </div>
</div>
